import * as angular from "angular";

export class RemindersService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/reminders";
    }

    queryreminders(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/queryreminders", data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/delete/" + data.id, data);
    }
}

angular.module("vcServices").service("RemindersService", RemindersService);
